import React from "react";
import { Link } from "react-router-dom";
import styles from "./Footer.module.scss";
import {SVGFacebook, SVGInstagram, SVGAdiona} from "../assets/PackageSVG";

type FooterLink = { label: string; to?: string };

/* `to` marks the links that have a page in the app; the rest are
   placeholders until those pages exist. */
const COLUMNS: { heading: string; links: FooterLink[] }[] = [
    { heading: "Product", links: [{ label: "Features" }, { label: "Pricing" }, { label: "API" }, { label: "Integrations" }] },
    { heading: "Company", links: [{ label: "About", to: "/about" }, { label: "Blog" }, { label: "Careers" }, { label: "Press" }] },
    { heading: "Support", links: [{ label: "Help Center" }, { label: "Contact" }] },
];

const LEGAL: FooterLink[] = [{ label: "Privacy" }, { label: "Terms" }];

const FooterAnchor = ({ link, className }: { link: FooterLink; className: string }) =>
    link.to
        ? <Link to={link.to} className={className}>{link.label}</Link>
        : <a href="#" className={className}>{link.label}</a>;

export const Footer = ()=> {
    return (
        <footer className={styles.footer}>
            <div className={styles.inner}>
                <div className={styles.top}>
                    <div className={styles.brand}>
                        <Link to="/" className={styles.logo} aria-label="Adiona home">
                            <SVGAdiona aria-hidden="true" />
                            <span className={styles.logoText}>Adiona</span>
                        </Link>
                        <p className={styles.tagline}>
                            Transforming travel planning with AI-powered personalization and smart budget management.
                        </p>
                        <div className={styles.social}>
                            <a href="#" className={styles.socialLink} aria-label="Adiona on Instagram">
                                <SVGInstagram aria-hidden="true" />
                            </a>
                            <a href="#" className={styles.socialLink} aria-label="Adiona on Facebook">
                                <SVGFacebook aria-hidden="true" />
                            </a>
                        </div>
                    </div>

                    <nav className={styles.columns} aria-label="Footer">
                        {COLUMNS.map((column) => (
                            <div key={column.heading}>
                                <h4 className={styles.heading}>{column.heading}</h4>
                                <ul className={styles.list}>
                                    {column.links.map((link) => (
                                        <li key={link.label}><FooterAnchor link={link} className={styles.link} /></li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </nav>
                </div>

                <div className={styles.bottom}>
                    <p className={styles.copyright}>© {new Date().getFullYear()} Adiona. All rights reserved.</p>
                    <ul className={styles.legal}>
                        {LEGAL.map((link) => (
                            <li key={link.label}><FooterAnchor link={link} className={styles.link} /></li>
                        ))}
                    </ul>
                </div>
            </div>
        </footer>
    )
}
